import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import useInfoForm from "./useInfoForm";
import Container from "react-bootstrap/Container";
import {FieldsToRows} from "../information/infoFields";
import {makeStyles} from "@material-ui/core";
import Row from "react-bootstrap/Row";
import _ from 'lodash';
const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '100vh'
    },
    textField: {
        width: '100%'
    },
    dateField: {},
    label: {
        fontSize: '0.75rem',
        color: 'rgba(0, 0, 0, 0.54)'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    }
}));

const AddField = ({valid, value}, ref) => {
    const classes = useStyles();
    const [values, setValues] = useState({
        type: {
            label: 'Type',
            type: 'select',
            value: '',
            required: 'Du må velge type',
            possibleValues: [{key: 'text', value: 'tekst'}, {key: 'number', value: 'nummer'}, {key: 'mobile', value: 'mobil'}, {key: 'boolean', value: 'Ja/Nei'}, {key: 'select', value: 'Rullegardin'}],
            position: 1
        },
        label: {
            label: 'Navn',
            type: 'text',
            value: '',
            regex: '\\w',
            required: 'Du er nødt til å ha et navn',
            helperText: 'Det som vil vises på feltet slik Navn vises her',
            position: 2
        },
        helperText: {
            label: 'Hjelpetekst',
            type: 'text',
            value: '',
            helperText: 'Hjelpetekst til feltet. Vil vises som denne teksten.',
            position: 3
        },
        position: {
            label: 'Posisjon',
            type: 'number',
            value: '',
            helperText: 'Posisjonen for feltet',
            position: 4
        },
        isRequired: {
            label: 'Påkrevd felt',
            type: 'boolean',
            value: false,
            position: 5
        },
        selectOptions: {
            label: 'Rullegardin alternativer',
            type: 'text',
            value: '',
            helperText: 'Skriv inn alternativene adskilt med komma, f.eks: Ja, Nei, Kanskje',
            position: 6,
            hidden: true
        },
        showOnCompanion: {
            label: 'Vis på ledsager',
            type: 'boolean',
            value: true,
            helperText: 'Skal dette feltet vises for ledsager?',
            position: 7
        }
    });

    const form = useInfoForm(values, setValues);

    useEffect(() => {
        if (value) {
            const newValues = _.cloneDeep(values);
            newValues.type.value = value.type;
            newValues.label.value = value.label;
            newValues.helperText.value = value.helperText;
            newValues.position.value = value.position;
            newValues.isRequired.value = !!value.required;
            newValues.showOnCompanion.value = value.showOnCompanion !== false;
            if (value.type === 'select' && value.possibleValues) {
                newValues.selectOptions.value = value.possibleValues.map(v => typeof v === 'string' ? v : v.value).join(', ');
                newValues.selectOptions.hidden = false;
            }
            setValues(newValues);
        }
    }, [value])

    useEffect(() => {
        const newValues = _.cloneDeep(values);
        const shouldShow = values.type.value === 'select';
        if (newValues.selectOptions.hidden !== !shouldShow) {
            newValues.selectOptions.hidden = !shouldShow;
            setValues(newValues);
        }
    }, [values.type.value])

    useImperativeHandle(ref, () => ({
        hasErrors: () => form.hasErrors(),
        values
    }));

    useEffect(() => {
        valid(!form.hasErrors());
    }, [values])

    return (
        <Container>
            <Row className="justify-content-center setup-trip" md={10}>
                <Container>
                    <form noValidate autoComplete="off">
                        {
                            FieldsToRows({values, classes, infoForm: form})
                        }
                    </form>
                </Container>
            </Row>
        </Container>
    )
};

export default forwardRef(AddField);
